/**
 * initAnimNodePulse
 *
 * Animates the nodes on the page with a pulse effect.
 * Uses GSAP for animations and jQuery InView plugin to handle video play/pause.
 * 
 * Example usage:
 * var pulse = gsap.timeline({ repeat: -1 });
 * pulse.add(animPulse());
 *
 * @author Co-Pilot, matt.breiwick
 */
import { gsap } from 'gsap';

export default function initAnimNodePulse() {
    function animPulse() {
        var tlPulse = gsap.timeline();
        // Find all pulse groups
        const pulseGroups = document.querySelectorAll('[class*="--pulse-"]');
        pulseGroups.forEach((pulseGroup, i) => {
            // Find all rings in this pulse group
            const rings = pulseGroup.querySelectorAll('[class*="--ring-"]');
            rings.forEach((ring, j) => {
                // Build a label for GSAP timeline (e.g., "pulse1", "pulse1+=0.25")
                const label = `pulse${i + 1}${j === 1 ? '+=0.25' : ''}`;
                tlPulse.fromTo(
                    ring,
                    { opacity: 1, scale: 1 },
                    {
                        duration: 3,
                        opacity: 0,
                        scale: 5,
                        immediateRender: false,
                        ease: "expo.out",
                        onComplete: () => {
                            gsap.set(ring, { scale: 1 });
                        }
                    },
                    label
                );
            });
        });
        return tlPulse;
    }

    var pulse = gsap.timeline({ repeat: -1 });
    pulse.add(animPulse());
}